exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-check{\n    margin-left: -1.3%;\n}\n", ""]);

